import React, { useState } from "react";
import { Menu } from "antd";
import { FormattedMessage } from "react-intl";
import MenuWrapper from "./SubMenu.style";
import ChildrenAnimationWrapper from "../animations/ChildrenAnimationWrapper";
import AnimationChildWrapper from "../animations/AnimationChildWrapper";

const SubMenu = (props) => {
  const { onMenuSelect, items, selectedKeys } = props;
  const [openKeys, setOpenKeys] = useState(["generalDetails"]);

  const onOpenChange = (keys) => {
    const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
    setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
  };

  return (
    <MenuWrapper>
      <Menu
        mode="inline"
        defaultSelectedKeys={[items[0].name]}
        defaultOpenKeys={[items[0].name]}
        openKeys={openKeys}
        style={{ height: "100%" }}
        className="light"
        onOpenChange={onOpenChange}
        selectedKeys={selectedKeys}
        onSelect={onMenuSelect}
        items={items.map((item, i) => ({
          label: (
            <div itemKey={i}>
              {item.icon}
              <FormattedMessage id={`app.${item.category}.${item.name}`} />
            </div>
          ),
          key: item.name,
        }))}
      />
    </MenuWrapper>
  );
};

export default SubMenu;
